import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/styles/bootstrap.css";
import useDepartedSearch from "../../hooks/useDepartedSearch";
import DepartedListElement from "../../components/departed/DepartedListElement";
import CircularProgress from "@mui/joy/CircularProgress";
import ListGroup from "react-bootstrap/ListGroup";
import ListContainer from "../../components/containers/ListContainer";

function DepartedList() {
  const { t } = useTranslation();

  const [query, setQuery] = useState('')
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    setPageNumber(0)
  }, []);

  useEffect(() => {
    setPageNumber(0)
  }, [query]);

  const {
    departeds,
    hasMore,
    loading,
    error
  } = useDepartedSearch(query, pageNumber)

  const observer = useRef()
  const lastDepartedElementRef = useCallback(node => {
    if (loading) return
    if (observer.current) observer.current.disconnect()
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setPageNumber(prevPageNumber => prevPageNumber + 1)
      }
    })
    if (node) observer.current.observe(node)
  }, [loading, hasMore])


  // function handleSearch(e) {     //to add a search function later
  //   setQuery(e.target.value)
  //   setPageNumber(0)
  // }

  return (
    <div className={"list-forming"}>
      <ListContainer>
        <h4>{t("departedList")}</h4>
        {/*<input type="text" className={"grave-form input my-3"} value={query} onChange={handleSearch}></input>*/} {/*to add a search function later*/}

        {departeds.map((departed, index) => (
          <ListGroup key={departed.uuid + index} as="ol">
            {(departeds.length === index + 1) ?
              (<ListGroup.Item
                key={departed.uuid + index + "1"}
                ref={lastDepartedElementRef}
                as="li"
                className="m-1 d-flex justify-content-between align-items-start listed-element listed-element-hover"
              >
                <DepartedListElement
                  departed={departed}/>
              </ListGroup.Item>) :
              (
                <ListGroup.Item
                  key={departed.uuid + index + "2"}
                  as="li"
                  className="m-1 d-flex justify-content-between align-items-start listed-element listed-element-hover"
                >
                  <DepartedListElement
                    departed={departed}/>
                </ListGroup.Item>)
            }
          </ListGroup>
        ))}
        <div>
          {loading ? (
            <div
              className={"m-2"}
            >
              <CircularProgress thickness={5}/>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div>{error && t("error")}</div>
      </ListContainer>
    </div>
  );
}

export default DepartedList;
